export default __webpack_public_path__ + "static/media/img14.22e26bd1.png";